import { useContext } from 'react';
import styles from './styles.module.scss';
import { AppContext } from '@/common/hooks/useAppContext';
import { Locales } from '@/lang/types';

export const LangSwitcher = () => {
  const { lang, setLang } = useContext(AppContext);
  const checked = lang === Locales.ru;

  const handler = () => {
    setLang();
    const nextValue = lang === Locales.ru ? Locales.kz : Locales.ru;
    localStorage.setItem('lang', nextValue);
  };

  return (
    <div className={styles.switcherWrapper}>
      <span>KZ</span>
      <button
        id="lang-switcher-button"
        className={styles.switcher}
        onClick={handler}
      >
        <div className={`${styles.thumb} ${checked ? styles.checked : ''}`} />
      </button>
      <span>RU</span>
    </div>
  );
};
